import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const Layout = resolve => require(['@/pages/Layout/Layout'], resolve)
const Login = resolve => require(['@/pages/Login/Login'], resolve)
const Register = resolve => require(['@/pages/Register/Register'], resolve)
const Home = resolve => require(['@/pages/Home/Home'], resolve)
const ProjectDetails = resolve => require(['@/pages/ProjectDetails/ProjectDetails'], resolve)
const ProjectDetailsMaster = resolve => require(['@/pages/ProjectDetailsMaster/ProjectDetailsMaster'], resolve)

const ProjectMember = resolve => require(['@/pages/ProjectMember/ProjectMember'], resolve)
const ProjectMemberMaster = resolve => require(['@/pages/ProjectMemberMaster/ProjectMemberMaster'], resolve)
const ProjectNode = resolve => require(['@/pages/ProjectNode/ProjectNode'], resolve)
const ProjectNodeMaster = resolve => require(['@/pages/ProjectNodeMaster/ProjectNodeMaster'], resolve)

const Memorandum = resolve => require(['@/pages/Memorandum/Memorandum'], resolve)
const ContractMoney = resolve => require(['@/pages/ContractMoney/ContractMoney'], resolve)
const ContractMoneyMaster = resolve => require(['@/pages/ContractMoneyMaster/ContractMoneyMaster'], resolve)
const CollectionStatus = resolve => require(['@/pages/CollectionStatus/CollectionStatus'], resolve)
const CollectionStatusMaster = resolve => require(['@/pages/CollectionStatusMaster/CollectionStatusMaster'], resolve)

const IncreaseorDecrease = resolve => require(['@/pages/IncreaseorDecrease/IncreaseorDecrease'], resolve)
const IncreaseorDecreaseMaster = resolve => require(['@/pages/IncreaseorDecreaseMaster/IncreaseorDecreaseMaster'], resolve)

const SetbaseMess = resolve => require(['@/pages/SetbaseMess/SetbaseMess'], resolve)
const SetbaseMessMaster = resolve => require(['@/pages/SetbaseMessMaster/SetbaseMessMaster'], resolve)


const BuildingExpend = resolve => require(['@/pages/BuildingExpend/BuildingExpend'], resolve)
const ArtificialExpend = resolve => require(['@/pages/ArtificialExpend/ArtificialExpend'], resolve)
const OtherExpend = resolve => require(['@/pages/OtherExpend/OtherExpend'], resolve)
const PhotoFile = resolve => require(['@/pages/PhotoFile/PhotoFile'], resolve)
const PhotoFileMaster = resolve => require(['@/pages/PhotoFileMaster/PhotoFileMaster'], resolve)

const ProjectLog = resolve => require(['@/pages/ProjectLog/ProjectLog'], resolve)
const ResetTemplate = resolve => require(['@/pages/ResetTemplate/ResetTemplate'], resolve)
const SiteSign = resolve => require(['@/pages/SiteSign/SiteSign'], resolve)


const Find = resolve => require(['@/pages/Find/Find'], resolve)
const Find_company = resolve => require(['@/pages/Find/Find_company'], resolve)
const Find_office = resolve => require(['@/pages/Find/Find_office'], resolve)
const Find_znz = resolve => require(['@/pages/Find/Find_znz'], resolve)

const Member = resolve => require(['@/pages/Member/Member'], resolve)
const Addproject = resolve => require(['@/pages/Addproject/Addproject'], resolve)
const My = resolve => require(['@/pages/My/My'], resolve)

const SubPage = resolve => require(['@/pages/SubPage/SubPage'], resolve)
const ProjectSta_my = resolve => require(['@/pages/ProjectSta/ProjectSta_my'], resolve)
const ProjectSta_co = resolve => require(['@/pages/ProjectSta/ProjectSta_co'], resolve)
const SignTotal = resolve => require(['@/pages/SignTotal/SignTotal'], resolve)
const Introduction = resolve => require(['@/pages/Introduction/Introduction'], resolve)
const Receivables = resolve => require(['@/pages/Receivables/Receivables'], resolve)
const Dealwith = resolve => require(['@/pages/Dealwith/Dealwith'], resolve)
const SetCompany = resolve => require(['@/pages/SetCompany/SetCompany'], resolve)
const SetLogoName = resolve => require(['@/pages/SetLogoName/SetLogoName'], resolve)
const SetRole = resolve => require(['@/pages/SetRole/SetRole'], resolve)
const SetDecorationType = resolve => require(['@/pages/SetDecorationType/SetDecorationType'], resolve)
const SetContractType = resolve => require(['@/pages/SetContractType/SetContractType'], resolve)
const SetFundType = resolve => require(['@/pages/SetFundType/SetFundType'], resolve)


const SetChannelSource = resolve => require(['@/pages/SetChannelSource/SetChannelSource'], resolve)
const SetRecordType = resolve => require(['@/pages/SetRecordType/SetRecordType'], resolve)
const SetorEidt = resolve => require(['@/pages/SetorEidt/SetorEidt'], resolve)
const SetScheduleTemplate = resolve => require(['@/pages/SetScheduleTemplate/SetScheduleTemplate'], resolve)
const SetTemplateDetails = resolve => require(['@/pages/SetTemplateDetails/SetTemplateDetails'], resolve)

const SetMaterials = resolve => require(['@/pages/SetMaterials/SetMaterials'], resolve)
const SetMaterialsBrand = resolve => require(['@/pages/SetMaterialsBrand/SetMaterialsBrand'], resolve)
const SetMaterialsModel = resolve => require(['@/pages/SetMaterialsModel/SetMaterialsModel'], resolve)
const SetMaterialsModelDetail = resolve => require(['@/pages/SetMaterialsModelDetail/SetMaterialsModelDetail'], resolve)

const SetDepartment = resolve => require(['@/pages/SetDepartment/SetDepartment'], resolve)
const EditMember = resolve => require(['@/pages/EditMember/EditMember'], resolve)


const System = resolve => require(['@/pages/System/System'], resolve)
const SetAd = resolve => require(['@/pages/SetAd/SetAd'], resolve)
const ApplyVIP = resolve => require(['@/pages/ApplyVIP/ApplyVIP'], resolve)
const VipMess = resolve => require(['@/pages/VipMess/VipMess'], resolve)
const Suggest = resolve => require(['@/pages/Suggest/Suggest'], resolve)
const ZnzCourse = resolve => require(['@/pages/ZnzCourse/ZnzCourse'], resolve)
const RegisterAgain = resolve => require(['@/pages/RegisterAgain/RegisterAgain'], resolve)
const WaitAudit =resolve => require(['@/pages/WaitAudit/WaitAudit'], resolve)



//业主的一些页面
const LayoutMaster = resolve => require(['@/pages/LayoutMaster/LayoutMaster'], resolve)
const HomeMaster = resolve => require(['@/pages/HomeMaster/HomeMaster'], resolve)
const FindMaster = resolve => require(['@/pages/FindMaster/FindMaster'], resolve)
const FindMaster_office = resolve => require(['@/pages/FindMaster/FindMaster_office'], resolve)
const FindMaster_znz = resolve => require(['@/pages/FindMaster/FindMaster_znz'], resolve)
const MemorandumMaster = resolve => require(['@/pages/MemorandumMaster/MemorandumMaster'], resolve)
const SiteSignMaster = resolve => require(['@/pages/SiteSignMaster/SiteSignMaster'], resolve)

Vue.use(Router)



export default new Router({
    routes: [
        {
            path: '/', name: 'Layout', component: Layout, redirect: '/login',     //主体页面
            children: [
                { path: 'home', name: 'Home', component: Home,meta:{auth:true} },
                {
                    path: 'find', name: 'Find', component: Find, redirect: "/find/findcompany",
                    children: [
                        { path: 'findcompany', name: 'Find_company', component: Find_company,meta:{auth:true} },
                        { path: 'findoffice', name: 'Find_office', component: Find_office ,meta:{auth:true}},
                        { path: 'findznz', name: 'Find_znz', component: Find_znz ,meta:{auth:true}},
                    ]
                },
                { path: 'addproject', name: 'Addproject', component: Addproject,meta:{auth:true} },
                { path: 'member', name: 'Member', component: Member,meta:{auth:true} },
                { path: 'my', name: 'My', component: My ,meta:{auth:true}},
            ]
        },
        {
            path: '/layoutMaster', name: 'LayoutMaster', component: LayoutMaster, redirect: '/homeMaster',     //业主主体页面
            children: [
                { path: 'homeMaster', name: 'HomeMaster', component: HomeMaster,meta:{auth:true} },
                {
                    path: 'findMaster', name: 'FindMaster', component: FindMaster,
                    redirect: '/layoutMaster/findMaster/findMasteroffice',
                    children: [
                        { path: 'findMasteroffice', name: 'FindMaster_office', component: FindMaster_office,meta:{auth:true} },
                        { path: 'findMasterznz', name: 'FindMaster_znz', component: FindMaster_znz ,meta:{auth:true}},
                    ]
                },
            ]
        },

        {
            path: '/subPage', name: 'SubPage', component: SubPage, children: [        //子页面
                { path: 'projectDetails', name: 'ProjectDetails', component: ProjectDetails,meta:{auth:true} },
                { path: 'projectDetailsMaster', name: 'ProjectDetailsMaster', component: ProjectDetailsMaster,meta:{auth:true} },
                { path: 'projectNode', name: 'ProjectNode', component: ProjectNode ,meta:{auth:true}},
                { path: 'projectNodeMaster', name: 'ProjectNodeMaster', component: ProjectNodeMaster ,meta:{auth:true}},
                { path: 'projectMember', name: 'ProjectMember', component: ProjectMember ,meta:{auth:true}},
                { path: 'projectMemberMaster', name: 'ProjectMemberMaster', component: ProjectMemberMaster ,meta:{auth:true}},
                
                { path: 'memorandum', name: 'Memorandum', component: Memorandum,meta:{auth:true} },
                { path: 'memorandumMaster', name: 'MemorandumMaster', component: MemorandumMaster,meta:{auth:true} },
                
                { path: 'contractMoney', name: 'ContractMoney', component: ContractMoney,meta:{auth:true} },
                { path: 'contractMoneyMaster', name: 'ContractMoneyMaster', component: ContractMoneyMaster,meta:{auth:true} },
                { path: 'collectionStatus', name: 'CollectionStatus', component: CollectionStatus ,meta:{auth:true}},
                { path: 'collectionStatusMaster', name: 'CollectionStatusMaster', component: CollectionStatusMaster ,meta:{auth:true}},
                
                { path: 'increaseorDecrease', name: 'IncreaseorDecrease', component: IncreaseorDecrease,meta:{auth:true} },
                { path: 'increaseorDecreaseMaster', name: 'IncreaseorDecreaseMaster', component: IncreaseorDecreaseMaster,meta:{auth:true} },
                
                { path: 'buildingExpend', name: 'BuildingExpend', component: BuildingExpend,meta:{auth:true} },
                { path: 'artificialExpend', name: 'ArtificialExpend', component: ArtificialExpend,meta:{auth:true} },
                { path: 'otherExpend', name: 'OtherExpend', component: OtherExpend,meta:{auth:true} },
                { path: 'photoFile', name: 'PhotoFile', component: PhotoFile ,meta:{auth:true}},
                { path: 'photoFileMaster', name: 'PhotoFileMaster', component: PhotoFileMaster ,meta:{auth:true}},
                
                { path: 'siteSign', name: 'SiteSign', component: SiteSign ,meta:{auth:true}},
                { path: 'siteSignMaster', name: 'SiteSignMaster', component: SiteSignMaster ,meta:{auth:true}},
                
                { path: 'projectLog', name: 'ProjectLog', component: ProjectLog,meta:{auth:true} },
                { path: 'setbaseMess', name: 'SetbaseMess', component: SetbaseMess,meta:{auth:true} },
                { path: 'setbaseMessMaster', name: 'SetbaseMessMaster', component: SetbaseMessMaster,meta:{auth:true} },
                

                { path: 'signTotal', name: 'SignTotal', component: SignTotal,meta:{auth:true} },
                { path: 'projectStamy', name: 'ProjectSta_my', component: ProjectSta_my,meta:{auth:true} },
                { path: 'projectStaco', name: 'ProjectSta_co', component: ProjectSta_co,meta:{auth:true} },
                { path: 'introduction', name: 'Introduction', component: Introduction,meta:{auth:true} },
                { path: 'receivables', name: 'Receivables', component: Receivables,meta:{auth:true} },
                { path: 'dealwith', name: 'Dealwith', component: Dealwith,meta:{auth:true} },
                { path: 'setCompany', name: 'SetCompany', component: SetCompany,meta:{auth:true} },
                { path: 'setLogoName', name: 'SetLogoName', component: SetLogoName,meta:{auth:true} },
                { path: 'setRole', name: 'SetRole', component: SetRole,meta:{auth:true} },
                { path: 'setDecorationType', name: 'SetDecorationType', component: SetDecorationType,meta:{auth:true} },
                { path: 'setContractType', name: 'SetContractType', component: SetContractType,meta:{auth:true} },
                { path: 'resetTemplate', name: 'ResetTemplate', component: ResetTemplate,meta:{auth:true} },
                { path: 'setFundType', name: 'SetFundType', component: SetFundType,meta:{auth:true} },
               
                
                { path: 'setChannelSource', name: 'SetChannelSource', component: SetChannelSource,meta:{auth:true} },
                { path: 'setRecordType', name: 'SetRecordType', component: SetRecordType,meta:{auth:true} },
                { path: 'setorEidt', name: 'SetorEidt', component: SetorEidt,meta:{auth:true} },
                { path: 'setScheduleTemplate', name: 'SetScheduleTemplate', component: SetScheduleTemplate,meta:{auth:true} },
                { path: 'setTemplateDetails', name: 'SetTemplateDetails', component: SetTemplateDetails,meta:{auth:true} },


                { path: 'setMaterials', name: 'SetMaterials', component: SetMaterials,meta:{auth:true} },
                { path: 'setMaterialsBrand', name: 'SetMaterialsBrand', component: SetMaterialsBrand ,meta:{auth:true}},
                { path: 'setMaterialsModel', name: 'SetMaterialsModel', component: SetMaterialsModel,meta:{auth:true} },
                { path: 'setMaterialsModelDetail', name: 'SetMaterialsModelDetail', component: SetMaterialsModelDetail,meta:{auth:true} },

                { path: 'setDepartment', name: 'SetDepartment', component: SetDepartment,meta:{auth:true} },
                { path: 'editMember', name: 'EditMember', component: EditMember,meta:{auth:true} },

                { path: 'setAd', name: 'SetAd', component: SetAd,meta:{auth:true} },
                { path: 'applyVIP', name: 'ApplyVIP', component: ApplyVIP,meta:{auth:true} },
                { path: 'system', name: 'System', component: System,meta:{auth:true} },
                { path: 'vipMess', name: 'VipMess', component: VipMess,meta:{auth:true} },
                { path: 'suggest', name: 'Suggest', component: Suggest,meta:{auth:true} },
                { path: 'znzCourse', name: 'ZnzCourse', component: ZnzCourse,meta:{auth:true} },
                { path: 'registerAgain', name: 'RegisterAgain', component: RegisterAgain,meta:{auth:true} },
                { path: 'waitAudit', name: 'WaitAudit', component: WaitAudit,meta:{auth:true} },
                

            ]
        },
        { path: '/login', name: 'Login', component: Login },
        { path: '/register', name: 'Register', component: Register },


    ]
})

/**
 * 导航地图
 * Login登陆
 * Register 注册
 * Home项目主页
 * ProjectDetails 项目详情
 * ProjectNode    项目节点详情
 * ProjectMember  项目成员
 * Initializing  初始化排期
 * Memorandum    内部沟通备忘录
 * ContractMoney 合同金额和构成
 * CollectionStatus 收款状态
 * IncreaseorDecrease 增减项
 * BuildingExpend 建材支出记录
 * ArtificialExpend 人工支出记录
 * OtherExpend    其他支出记录
 * PhotoFile   照片留档（现场写真照片|装修合同照片|设计图照片|预算清单照片|材料清单照片|水电照片留档）
 * ProjectLog  项目日志
 * SiteSign  工地签到
 * ResetTemplate 重设模板
 * SetbaseMess 基本信息
 *
 * Find消息
 * Find_company公司消息
 * Find_office官方消息
 * Find_znz 装企品牌秀
 * ArticleContent 装企品牌秀文章内容
 * Addproject添加项目
 *
 * Member成员
 * My 我的
 * Dealwith 我的待办
 * Introduction转介绍客户
 * ProjectSta 项目统计
 * Receivables 合同收款确认
 * SignTotal 签到统计
 * SetCompany调整公司设置
 * SetLogoName 设置公司名称和logo
 * SetRole 设置成员角色
 * SetDecorationType 设置装修类型
 * SetContractType 设置款项构成
 * SetFundType  设置收款状态
 * SetChannelSource 设置渠道来源
 * SetRecordType 设置建材支出分类
 * SetorEidt 后面的几个设置页面统一页面
 * SetScheduleTemplate 设置项目模板
 * SetTemplateDetails  设置项目模板详情
 *
 * SetDepartment 设置部门和员工
 * EditMember    编辑成员
 *
 *
 *
 * SetMaterials 设置建材库
 * SetMaterialsBrand 设置建材品牌
 * SetMaterialsModel 设置建材型号
 * SetMaterialsModelDetail 设置建材型号详情页
 * SetAd 设置广告页
 * ApplyVIP  申请VIP
 * VipMess vip信息
 * Suggest 意见反馈
 * znzCourse 装内助教程
 * RegisterAgain注册一个独立新公司
*/






// WEBPACK FOOTER //
// ./src/router/index.js